import { handleAction } from 'redux-actions';
import { setForeignCardAction } from './actions';
const initialState = false;
const reducer = handleAction(setForeignCardAction, (state, action) => action.payload, initialState);
export default reducer;
